<template>
	<div>
		<div
			class="form-check cm-form-check"
			:class="[className, activeFilter ?? 'active']"
		>
			<input
				class="form-check-input"
				type="checkbox"
				id="check-delivery"
				v-model="model"
				@change="updateFilter()"
				true-value="1"
				false-value="2"
				:checked="activeFilter === 1"
			/>
			<label class="form-check-label" for="check-delivery"
				>Sofort verfügbar
			</label>
		</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'FormDeliveryCheck',
	data() {
		return {
			model: 2,
		}
	},
	computed: {
		activeFilter() {
			if (store.state.delivery) {
				return 1
			} else {
				return 2
			}
		},
	},
	props: {
		className: {
			type: String,
			default: '',
		},
	},
	methods: {
		updateFilter() {
			if (this.model === '1') {
				store.state.delivery = 'now'
			} else {
				store.state.delivery = ''
			}
			this.$emit('updateFilter')
		},
	},
	created() {
		if (store.state.delivery) {
			this.model = 1
		}
		this.unsubscribe = store.subscribe((mutation, state) => {
			if (
				mutation.type === 'deleteFilter' ||
				mutation.type === 'deleteAllFilter'
			) {
				if (store.state.delivery === '' && this.model === '1') {
					this.model = '2'
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	},
}
</script>
<style lang="scss">
.cm-form-check {
	&.active .form-check-label {
		color: $primary;
	}
}
</style>
